import { Action } from 'redux';

import { EditSimulation } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface EditSimulationReduxAction extends Action {
  readonly simulation: IContentInfo;
}

export function editSimulation(simulation: IContentInfo): EditSimulationReduxAction {
  return {
    type: EditSimulation,
    simulation
  };
}
